export default __webpack_public_path__ + "static/media/multi-hop.8cc27f88.svg";